module.exports = __webpack_public_path__ + "static/media/status-L.e45d5067.svg";